// extracted by mini-css-extract-plugin
module.exports = {"link__text":"link_link__text__ATthk"};